export const navMenuItems = [
  {
    name: "Dashboard",
    icon: "dashboard",
    link: "/",
    allowedDept: [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    name: "Trials",
    icon: "partnerDecision",
    link: "/partnerMeetings",
    allowedDept: [2],
    authorities: [140],
  },
];
export const PHONE_REGEX = /^(\+91[-\s]?)?[6-9]\d{9}$/;
// export const NAME_REGEX = /^(?!\d+$)(?!\s+$)[a-zA-Z0-9\s.]+$/;
export const NAME_REGEX = /^(?!\d+$)(?!\s+$).+$/;

export const Hospital_REGEX = /^(?!\d+$)(?!\s+$)[a-zA-Z0-9\s.,]+$/;
export const SANITISE_REGEX = /[\u0300-\u036F]{2,}/;



export const StatusChangeHeading = "Are you sure you want to change patient status ?";

export const SubmitAppointmentConfirmMessage = "Are you sure you want to submit?";
export const SubmitAppointmentCompleteQueries = "Complete all the queries and resolve for submit.";

export const TemplateStatus = [{ id: 1, name: "All" }, { id: 2, name: "Completed" }, { id: 3, name: "Saved as Draft" }]

export const GenderList = [{ id: 1, name: "Male" }, { id: 2, name: "Female" }, { id: 3, name: "Others" }]

export const formTemplateDropdownList = [
  {
    id: "1",
    name: "Screening and Enrollment"
  },
  {
    id: "2",
    name: "Apheresis"
  },
  {
    id: "3",
    name: "Bridging Therapy"
  },
  {
    id: "4",
    name: "Conditioning Chemotherapy"
  },
  {
    id: "5",
    name: "Infusion"
  },
  {
    id: "6",
    name: "Post Infusion Follow Up"
  },
  {
    id: "7",
    name: "Short Term Follow Up"
  },
  {
    id: "8",
    name: "Long Term Follow Up"
  }
];

export const sortTableByOrder = (data, columnIndex, order = 'asc') => {
  // Validate columnIndex
  if (data?.length === 0 || columnIndex < 0 || columnIndex >= data[0]?.length) {
    return [];
  }

  const sortedData = [...data];


  return sortedData?.sort((a, b) => {
    const valueA = a[columnIndex];
    const valueB = b[columnIndex];

    // Determine the sort order
    const direction = order === 'asc' ? 1 : -1;

    if (typeof valueA === 'number' && typeof valueB === 'number') {
      return (valueA - valueB) * direction;
    } else {
      // Compare as strings, converting to string if necessary
      const strA = String(valueA).toLowerCase();
      const strB = String(valueB).toLowerCase();
      if (strA < strB) return -1 * direction;
      if (strA > strB) return 1 * direction;
      return 0; // They are equal
    }
  });
}

export const formatLabel = (text) => {
  return text
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

// @info using for the status and colors convertion according to status code.
export const getStatusConfig = (status) => {
  switch (status) {
    case 0:
      return { text: 'Pending', color: "#f8cebf", text_color: '#e2612b' }
    case 1:
      return { text: "Submitted", color: "#afe6e5", text_color: '#009d93' };
    case 2:
      return { text: "Published", color: "#beebd0", text_color: '#00994d' };
    case 3:
      return { text: "Draft", color: "#FFEDCB", text_color: '#ff960b' };
      //@info adding here pending as a fallback in case of fresh template create
    default:
      return { text: 'Pending', color: "#f8cebf", text_color: '#e2612b' }
  }
};